import ProductPage from "../Components/Products/ProductPage";
import AllProducts from "../Components/Products/AllProducts";
import LandingPage from "../Pages/LandingPage";
import UserAccount from "../Authentication/UserAccount";
import WishList from "../Pages/WishList";
import ContactUs from "../Pages/Contact";
import AboutUs from "../Pages/AboutUs";
import TermsAndConditions from "../Pages/TermsAndConditions";
import ShippingPolicy from "../Pages/ShippingPolicy";
import CancellationPolicy from "../Pages/CancellationPolicy";
import MultiVendorLandingPage from "../Pages/MultiVendorLanding";
import AaraClouds from "../Pages/AaraClouds";
import CartPages from "../Pages/CartPages";
import YourCart from "../Pages/YourCart";
import Payment from "../Pages/Payment";
import Productdetail from "../Pages/Productdetail";
import Yearly from "../Sub/Yearly";
import Monthly from "../Sub/Monthly";
import Quater from "../Sub/Quater";
import Plann from "../Sub/Plann";
import Wallet from "../Sub/Wallet";
import Checkoutplan from "../Sub/Checkoutplan";
import Cart1 from "../Sub/Cart1";
import Subscription from "../Sub/Subscription";
// import Devops from "../Devops";
import News from "../News";
import NewsDetail from "../News/NewsDetail";
import Blog1 from "../Blog1";
import BlogDetails from "../BlogDetails";
import Career from "../Career";
import Devops from "../Dedicated";
import Dedicated from "../Devops";

const routes = [
  {
    id: 1,
    path: "/",
    element: <AaraClouds />,
  },
  {
    id: 2,
    path: "/home",
    element: <AaraClouds />,
  },

  {
    id: 3,
    path: "/product/:id",
    element: <ProductPage />,
  },
  {
    id: 4,
    path: "/all-products",
    element: <AllProducts />,
  },
  {
    id: 5,
    path: "/user-account",
    element: <UserAccount />,
  },
  {
    id: 6,
    path: "/wish-list",
    element: <WishList />,
  },
  {
    id: 7,
    path: "/contact",
    element: <ContactUs />,
  },
  {
    id: 8,
    path: "/about-us",
    element: <AboutUs />,
  },
  {
    id: 9,
    path: "/terms-and-policy",
    element: <TermsAndConditions />,
  },
  {
    id: 10,
    path: "/shipping-policy",
    element: <ShippingPolicy />,
  },
  {
    id: 11,
    path: "/cancellation-policy",
    element: <CancellationPolicy />,
  },
  {
    id: 13,
    path: "/cart",
    element: <CartPages />,
  },
  {
    id: 14,
    path: "/yourcart",
    element: <YourCart />,
  },
  {
    id: 15,
    path: "/payment",
    element: <Payment />,
  },
  {
    id: 17,
    path: "/productdetail",
    element: <Productdetail />,
  },
  {
    id: 18,
    path: "/quater/:id/:variant_id/:id",
    element: <Quater />,
  },
  {
    id: 19,
    path: "/monthly/:id/:variant_id",
    element: <Monthly />,
  },
  {
    id: 20,
    path: "/yearly/:id/:variant_id",
    element: <Yearly />,
  },
  {
    id: 21,
    path: "/plan/:variant_id",
    element: <Plann />,
  },
  {
    id: 22,
    path: "/wallet",
    element: <Wallet />,
  },
  {
    id: 24,
    path: "/subscription",
    element: <Subscription />,
  },
  {
    id: 26,
    path: "/devops",
    element: <Devops />,
  },
  {
    id: 27,
    path: "/dedicated",
    element: <Dedicated />,
  },
  {
    id: 28,
    path: "/blog",
    element: <Blog1 />,
  },
  {
    id: 29,
    path: "/blogdetail/:id/:slug",
    element: <BlogDetails />,
  },
  {
    id: 30,
    path: "/career",
    element: <Career />,
  },
  {
    id: 30,
    path: "/new",
    element: <News />,
  },
  {
    id: 31,
    path: "/newsdetail/:id",
    element: <NewsDetail />,
  },
  {
    id: 32,
    path: "/check",
    element: <Checkoutplan />,
  },
  {
    id: 33,
    path: "/cartt",
    element: <Cart1 />,
  },
];
export default routes;
